import { getCognitoInstance } from '@/services/CognitoInstance';
import { useAuthStore } from '@/store';
import { inject } from 'vue';
import { useWhoAmI} from '@/hooks/index'




export default async () => {
    const authStore = useAuthStore();

    const checkValidSession = async () => {
        const whoAmI = useWhoAmI()
        const response = await whoAmI.whoAmI()
        if (response.status === 'logged-in' && response.user) {
            authStore.loggedInUser = {
                name: response.user.name,
                email: response.user.email,
            };
            authStore.lpiUser = isLpiUser(response.user.email)
            authStore.loggedIn = true;
        }
        else {
            authStore.loggedIn = false;
        }
    };

    const isLpiUser = (email: string) => {
        return email.includes('@leveragepoint.com')
    }

    return {
        checkValidSession
    }
}


